import styled from "styled-components";
import { space, layout, SpaceProps, LayoutProps } from "styled-system";
import { fieldFrame, fieldText } from "./fieldStyles";

type TextAreaProps = SpaceProps &
  LayoutProps & {
    /** Show the error state (same as aria-invalid). */
    invalid?: boolean | null;
  };

const TextArea = styled.textarea.attrs<TextAreaProps>((props) => ({
  "aria-invalid": props.invalid ? true : props["aria-invalid"],
}))<TextAreaProps>`
  display: block;
  width: 100%;
  padding: 8px 12px;
  line-height: 1.5;
  ${fieldFrame(":focus")};
  ${fieldText};
  ${space};
  ${layout};
  max-width: 100%;
`;

TextArea.defaultProps = {
  mb: 0,
};

export default TextArea;
